import $ from "jquery";

const loadLessonFavorite = async (lessonId) => {
  await $.get(`/collection_memberships/load_favorite?lesson_id=${lessonId}`);
};

const getFavoriteStatus = (lessonId) => {
  const $favoriteComponent = $(document).find(
    `[data-favorite-lesson=${lessonId}]`
  );
  return $favoriteComponent.data("favorited");
};

const getLessonFavoriteComponents = async () => {
  const favoriteIds = $(document)
    .find("[data-favorite-lesson]")
    .map((_, el) => $(el).data("favorite-lesson"));

  const favorites = await $.get(
    `/collection_memberships/favorited?lesson_ids=${$.makeArray(
      favoriteIds
    ).join(",")}`
  );

  return Object.entries(favorites).map(([key, isFavorite]) => ({
    lessonId: key,
    isFavorite,
  }));
};

const loadFavorites = async () => {
  const favorites = await getLessonFavoriteComponents();
  favorites.map(({ lessonId, isFavorite }) => {
    if (getFavoriteStatus(lessonId) !== isFavorite) {
      loadLessonFavorite(lessonId);
    }
  });
};

const favoriteActionComponent = {
  load: loadFavorites,
  loadLessonFavorite,
};

export default favoriteActionComponent;
